module.exports = __webpack_public_path__ + "img/client-13.d0f9564e.webp";